import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export interface ChatSource {
  title?: string;
  chunk?: string;
  [key: string]: unknown;
}

export interface ChatProductPreview {
  code: string;
  displayCode: string;
  name: string;
  category: string;
  series: string;
  dimension: string;
  thumbnailUrl: string;
  imageUrl: string;
  hiresUrl: string;
  view360Url: string;
}

export interface ChatSalesContact {
  fullName: string;
  nickname: string;
  phone: string;
  email: string;
  area: string;
  team: string;
  region: string;
  whatsappUrl: string;
}

export interface ChatResponse {
  message: string;
  sources: ChatSource[];
  sessionId: string;
  products?: ChatProductPreview[];
  salesContacts?: ChatSalesContact[];
}

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private readonly apiUrl = '/api/chat';
  private readonly sessionStorageKey = 'frantinco-chat-session-id';

  constructor(private http: HttpClient) {}

  sendMessage(userMessage: string, sessionId = this.getSessionId()): Observable<ChatResponse> {
    const message = userMessage.trim();

    if (!message) {
      return throwError(() => new Error('Pesan tidak boleh kosong.'));
    }

    return this.http.post<ChatResponse>(this.apiUrl, {
      message,
      sessionId,
    });
  }

  getSessionId(): string {
    const existingSessionId = sessionStorage.getItem(this.sessionStorageKey);

    if (existingSessionId) {
      return existingSessionId;
    }

    const sessionId = this.createSessionId();
    sessionStorage.setItem(this.sessionStorageKey, sessionId);

    return sessionId;
  }

  resetSession(): string {
    const sessionId = this.createSessionId();
    sessionStorage.setItem(this.sessionStorageKey, sessionId);

    return sessionId;
  }

  private createSessionId(): string {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
      return crypto.randomUUID();
    }

    return `frantinco-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}
